<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="masterList.tableQuery.search.userName"
              placeholder="请输入用户名"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="masterList.tableQuery.search.name"
              placeholder="请输入姓名"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="masterList.tableQuery.search.tel"
              placeholder="请输入电话"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="4">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @view="viewFun(arguments)"
        @delete="deleteFun(arguments)"
        @reset="resetFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 新增 修改 查看-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditViewTitle"
      :dialog-visible.sync="dialogAddEditViewVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 权限验证
import checkPermission from '@/utils/permission'
// 新增 修改
import addEditViewDialog from './components/addEditViewDialog'
// 数据请求
import { systemUserPageListApi, systemUserExportListApi, systemUserSaveOrUpdateApi } from '@/api/user'

export default {
  name: 'SystemUser',
  components: {
    CustomTable,
    TableOperation,
    addEditViewDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'system_user_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['user_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['user_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['user_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['user_reset_pw'],
            prop: 'reset',
            label: '重置密码',
            method: 'reset'
          },
          {
            permissionSigns: ['user_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['user_view'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            userName: '',
            name: '',
            tel: ''
          }
        },
        notPaging: true
      },
      id: null, // 选中的单据ID
      eventType: '',
      dialogAddEditViewTitle: '',
      dialogAddEditViewVisible: false,
      showUpdateBtn: false
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'organization', label: '所属组织', width: 200 },
      { prop: 'userName', filterColumn: 'user_name', label: '用户名', width: 150 },
      { prop: 'name', label: '名称', width: 100 },
      { prop: 'provinceName', filterColumn: 'province_name', label: '所在省区', width: 120 },
      { prop: 'cityName', filterColumn: 'city_name', label: '所在城市', width: 120 },
      { prop: 'department', label: '部门', width: 100 },
      { prop: 'post', label: '岗位', width: 100 },
      { prop: 'tel', label: '电话', width: 150 },
      { prop: 'roleNames', filterColumn: 'role_names', label: '角色', minWidth: 200 },
      { prop: 'initPassword', filterColumn: 'init_password', label: '初始化密码', width: 120 },
      { prop: 'typeStr', filterColumn: 'type', filterValue: 'type', label: '用户类型', width: 110, filterArray: [{ label: '管理员', value: 1 }, { label: '普通用户', value: 2 }] },
      { prop: 'sortStr', filterColumn: 'sort', filterValue: 'sort', label: '人员类型', width: 110, filterArray: [{ label: '内勤', value: 1 }, { label: '外勤', value: 2 }, { label: '分中心', value: 3 }] },
      { prop: 'statusStr', filterColumn: 'status', filterValue: 'status', label: '状态', width: 80, filterArray: [{ label: '正常', value: 1 }, { label: '禁用', value: 2 }] },
      { prop: 'lastLoginTimeStr', filterColumn: 'last_login_time', label: '最近登录时间', width: 160, isBetween: true },
      { prop: 'lastLoginIp', filterColumn: 'last_login_ip', label: '最近登录IP', minWidth: 160 },
      { prop: 'remark', label: '备注', width: 200 },
      { prop: 'operatorName', filterColumn: 'operator_name', label: '操作人', width: 100 },
      { prop: 'operationTimeStr', filterColumn: 'operation_time', label: '操作时间', width: 150, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    if (checkPermission(['user_edit'])) {
      this.showUpdateBtn = true
    }
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this
      _this.masterList.tableLoading = true
      systemUserPageListApi({ condition: JSON.stringify(_this.masterList.tableQuery) }).then(response => {
        _this.masterList.tableLoading = false
        _this.handleData(response.data.data || [])
        _this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 新增
    addFun () {
      let _this = this
      _this.eventType = 'add'
      _this.dialogAddEditViewVisible = !_this.dialogAddEditViewVisible
      _this.dialogAddEditViewTitle = '新增用户'
    },
    // 修改
    editFun (args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'edit'
      _this.dialogAddEditViewVisible = !_this.dialogAddEditViewVisible
      _this.dialogAddEditViewTitle = '修改用户'
    },
    // 查看
    viewFun (args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'view'
      _this.dialogAddEditViewVisible = !_this.dialogAddEditViewVisible
      _this.dialogAddEditViewTitle = '查看用户'
    },
    // 作废
    deleteFun (args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.$confirm('是否确定作废该用户？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        systemUserSaveOrUpdateApi({ id: args[0].id, status: 0, isDel: "1" }).then(res => {
          if (res.mark === '200') {
            _this.$message({ message: res.message, type: 'success' })
            _this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 重置密码
    resetFun (args) {
      let _this = this
      _this.$confirm('是否确定重置密码？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        systemUserSaveOrUpdateApi({ id: args[0].id, isResetPassword: "1" }).then(res => {
          if (res.mark === '200') {
            _this.$message({ message: res.message, type: 'success' })
            _this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      systemUserExportListApi({ condition: JSON.stringify(this.exportObj) }).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
